import { PersonProfileService } from '@openeducation/oe-it-services';
import { useQuery } from 'react-query';

import { useEnvironmentContext } from '../environment/environment.provider';

export const usePersonLiteProfileWithAvatar = (personId?: number) => {
  const { environment } = useEnvironmentContext();

  const {
    data: personProfile,
    isLoading: isLoadingPersonProfile,
    isRefetching: isRefetchingPersonProfile,
    error,
    refetch,
  } = useQuery(
    ['liteProfileWithAvatar', personId],
    () =>
      PersonProfileService.getLiteProfileWithAvatar(environment, personId, 50),
    {
      enabled: !!environment && !!personId,
    }
  );

  return {
    error,
    refetch,
    personProfile,
    isLoadingPersonProfile,
    isRefetchingPersonProfile,
  };
};
